import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import http from 'src/helper/http'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
  }

  state = {
    lang: langM.ar,
    language: 'en',
    applicationState: null,
    reason: '',
    showApplaView: false,
    pic: '',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    console.log('language', language)
    let a = localStorage.getItem('srt')
    if (a) {
      setDocumentTitle(a)
    }
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })
    let pic = this.getQueryString('id')
    if (pic) {
      let id = pic * 1
      this.setState({ pic, id })
      this.getIdInPic(id)
    }
    console.log(pic)
    // console.log(uid, 'uid')
  }
  getQueryString = (name) => {
    var url_string = window.location.href; // window.location.href
    var params = url_string.split('?')[1]; // 获取?号后面的参数 name=mick&age=20
    if (!params) return null; // 如果无参，返回null
    var vars = params.split(`${name}=`); // 将参数分割成数组 ['name=mick', 'age=20']
    console.log(vars)
    return vars[1];
  }

  getIdInPic = async (id) => {
    let res = await http.post('/withoutsign/activity/show', { id })
    if (res.code == 0) {
      setDocumentTitle(res.res.title)
      let a = localStorage.getItem('srt')
      if (a) {
        localStorage.removeItem('srt')
      } else {
        localStorage.setItem('srt', res.res.title)
        window.location.href = window.location.href
      }
      await this.setState({ pic: res.res.content })
    }
  }
  // 初始化/接口请求初始化

  render() {
    let { pic } = this.state
    return <div className='new-tespic' style={{ maxWidth: '7.5rem' }}>
      {pic && pic!='' ? <img src={pic} style={{ width: '7.5rem' }}></img> : "Loading..."}
    </div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/newTestPic/index.js